<template>
  <header class="pr-header">
    <div class="pr-login">
      <span class="pr-amount" @click="bf"><i class="el-icon-bell"></i><em> {{ amount }}</em></span>
      <span><i class="el-icon-s-custom"></i> {{ username }}</span>
      <span class="pr-login-flag" @click="handleLogoutClick">{{ loginFlag }}</span>
      <audio :src="audioUrl" autoplay loop id="alarmAudio"></audio>
    </div>
  </header>
</template>
<script>
import urls from '@/api/urls'
import {postData} from '@/api/'

export default {
  name: "headerBar",
  props: {},
  components: {},
  data() {
    return {
      amount: 0,
      audioUrl: '',
      loginFlag: '退出',
      username: localStorage.getItem('userName'),
    };
  },
  watch: {},
  created() {
  },
  mounted() {
    this.timer && clearInterval(this.timer)
    this.getAmount()
    this.timer = setInterval(() => {
      this.getAmount()
    }, 60 * 1000);
    this.$once('hook:beforeDestroy', () => { clearInterval(this.timer); })
  },
  methods: {
    handleLogoutClick() {
      postData({}, urls.logoutUrl).then(res => {
        console.log('登出接口----', res)
        localStorage.setItem('gasHomeToken', '')
        localStorage.setItem('gasHomeMenuList', '')
        this.$router.push('/')
        this.loginFlag = '退出'
      })
    },

    getAmount() {
      this.postData({}, this.urls.getNumUrl).then(res => {
        if (res.success) {
          this.amount = res.data || 0
          if (this.amount > 0) {
            this.audioUrl = "http://download.pchxiot.com/audio/bell.mp3"
          }
        } else {
          this.amount = 0
        }
        console.log('监控系统顶部铃铛显示数量---------', res)
      })
    },
    bf() {
      let audio = document.getElementById('alarmAudio');
      if (audio !== null) {
        //检测播放是否已暂停.audio.paused 在播放器播放时返回false.
        if (audio.paused) {
          audio.play();//audio.play();// 这个就是播放
        } else {
          audio.pause();// 这个就是暂停
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped="scoped">
.pr-header {
  height: 50px;
  line-height: 50px;
  color: #fff;
  background: rgb(4, 21, 39);
}

.pr-login {
  float: right;
  font-size: 14px;
}

.pr-login-flag {
  margin: 0 20px;
  cursor: pointer;

  &:hover {
    color: #1890ff;
  }
}

.pr-amount {
  position: relative;
  margin-right: 30px;

  i {
    font-size: 20px;
  }

  em {
    position: absolute;
    top: -10px;
    left: 12px;
    height: 16px;
    line-height: 16px;
    padding: 0 5px;
    border-radius: 10px;
    font-size: 12px;
    font-style: normal;
    background: red;
  }
}
</style>
